import { useAppSelector } from 'hooks/reduxHooks'
import { CRUISE_AVAILABLE_REGIONS } from 'constants/config/region'

function useCruiseInternationalMarket(): boolean {
  const currentRegionCode = useAppSelector(state => state.geo.currentRegionCode)

  return !CRUISE_AVAILABLE_REGIONS.has(currentRegionCode)
}

export default useCruiseInternationalMarket
